<template>
  <div class="box">
    <CustomNavBar title="旅游攻略" />
    <smallCard :data="strategyList" class="list" />
    <img class="bg-img1" :src="require('@/assets/bg01.png')">
  </div>
</template>

<script>
import CustomNavBar from "@/components/CustomNavBar";
import smallCard from "@/components/CustomCard/smallCard.vue";

import { mapGetters } from "vuex";
export default {
  name: "LIST",
  components: {
    CustomNavBar,
    smallCard,
  },
  computed: {
    ...mapGetters(["strategyList"]),
  },
  mounted() {
    this.$store.commit("set_istab", true);
  },
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  background: #f5f7fa;
  position: relative;

  .bg-img1 {
    position: absolute;
    left: 0;
    bottom: 50px;
    width: 200px;
    height: auto;
  }
}
</style>
